/**
 * There are 25 levels here, but we don't have to use them all.
 */ const shadows = [
    "none",
    "0px 1px 2px 0px #0D10170F",
    "0px 1px 2px 0px #0D10170A, 0px 1px 3px 0px #0D10171F",
    "0px 2px 4px -2px #0D10170A, 0px 4px 8px -2px #0D10171F",
    "0px 4px 8px -4px #0D10170A, 0px 12px 18px -6px #0D101714",
    "0px 8px 10px -6px #0D10170A, 0px 18px 22px -4px #0D101714",
    "0px 24px 46px -10px #0D101729",
    // Need to define 25 variants
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729",
    "0px 24px 46px -10px #0D101729"
];
export default shadows;

//# sourceMappingURL=index.js.map